var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWbnr(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 305 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4427 147.573C10.4427 228.892 76.364 294.813 157.683 294.813C239.001 294.813 304.923 228.892 304.923 147.573C304.923 66.2548 239.001 0.333496 157.683 0.333496C76.364 0.333496 10.4427 66.2548 10.4427 147.573ZM157.683 285.48C81.5187 285.48 19.776 223.737 19.776 147.573C19.776 71.4095 81.5187 9.66681 157.683 9.66681C233.847 9.66681 295.589 71.4095 295.589 147.573C295.589 223.737 233.847 285.48 157.683 285.48Z",
    fill: "url(#paint0_linear_2072_10783)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7001 273.425C43.7008 273.425 43.7014 273.425 43.7021 273.424L183.348 176.479L183.348 176.479C199.294 165.408 199.294 141.826 183.348 130.756L183.348 130.756L43.7021 33.8105C25.2431 20.993 0 34.2094 0 56.6706V250.564C0 273.024 25.2411 286.241 43.7001 273.425ZM47 213.919V93.3154L133.862 153.617L47 213.919ZM16.8952 72.416C16.8959 72.4165 16.8966 72.417 16.8973 72.4175L16.8952 72.416Z",
    fill: "#1DD8A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4659 183.231L34.3496 124.231H50.0586L58.9327 162.892H59.4209L69.5585 124.231H82.367L92.5046 162.978H92.9929L101.896 124.231H117.576L100.488 183.231H86.7896L76.1925 147.45H75.733L65.1359 183.231H51.4659Z",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.597 183.231V124.231H143.122C147.526 124.231 151.211 124.855 154.179 126.103C157.166 127.352 159.406 129.099 160.899 131.346C162.411 133.594 163.168 136.196 163.168 139.154C163.168 141.401 162.699 143.408 161.761 145.175C160.822 146.922 159.53 148.372 157.884 149.525C156.237 150.677 154.332 151.484 152.169 151.945V152.521C154.543 152.636 156.735 153.279 158.745 154.451C160.775 155.622 162.402 157.255 163.627 159.348C164.853 161.423 165.465 163.881 165.465 166.723C165.465 169.892 164.661 172.725 163.053 175.222C161.445 177.699 159.118 179.658 156.074 181.099C153.03 182.52 149.335 183.231 144.989 183.231H118.597ZM132.812 171.736H141.6C144.683 171.736 146.951 171.15 148.406 169.979C149.881 168.807 150.618 167.175 150.618 165.081C150.618 163.564 150.264 162.258 149.555 161.163C148.847 160.049 147.842 159.195 146.54 158.599C145.238 157.985 143.677 157.677 141.859 157.677H132.812V171.736ZM132.812 148.488H140.681C142.232 148.488 143.61 148.228 144.817 147.71C146.023 147.191 146.961 146.442 147.631 145.463C148.32 144.483 148.665 143.302 148.665 141.919C148.665 139.941 147.966 138.385 146.568 137.252C145.171 136.119 143.285 135.552 140.911 135.552H132.812V148.488Z",
    fill: "#474747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.504 124.231V183.231H205.443L182.037 149.179H181.664V183.231H167.448V124.231H179.682L202.829 158.225H203.317V124.231H217.504Z",
    fill: "#474747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.591 183.231V124.231H245.887C250.29 124.231 254.09 125.028 257.288 126.622C260.504 128.197 262.984 130.463 264.726 133.421C266.468 136.359 267.339 139.845 267.339 143.878C267.339 147.969 266.449 151.445 264.669 154.307C262.888 157.149 260.361 159.32 257.087 160.818C253.813 162.296 249.936 163.036 245.456 163.036H230.091V151.801H242.814C244.958 151.801 246.748 151.522 248.184 150.965C249.639 150.389 250.74 149.525 251.487 148.372C252.233 147.201 252.607 145.703 252.607 143.878C252.607 142.054 252.233 140.546 251.487 139.355C250.74 138.145 249.639 137.243 248.184 136.647C246.729 136.033 244.939 135.725 242.814 135.725H235.806V183.231H221.591ZM254.703 156.266L269.35 183.231H253.842L239.482 156.266H254.703Z",
    fill: "#474747"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 30.0002C37.2548 30.0002 48 40.7454 48 54.0002L48 254C48 267.255 37.2548 278 24 278C10.7452 278 1.03707e-05 267.255 9.79135e-06 254L1.04907e-06 54.0002C4.69686e-07 40.7454 10.7452 30.0002 24 30.0002Z",
    fill: "url(#paint1_linear_2072_10783)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2072_10783",
    x1: 160.75,
    y1: 266.315,
    x2: 160.75,
    y2: 28.8316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFFA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2072_10783",
    x1: 24.5,
    y1: 54.0002,
    x2: 24.5,
    y2: 254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFFA7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbnr);
export default __webpack_public_path__ + "static/media/wbnr.9bb179f1c956f1379ec742ec4162586b.svg";
export { ForwardRef as ReactComponent };